// @flow
import { clone } from 'ramda'

import type { Values } from './Types/Values'
import type { ExpandedSpecificationDTO, SpecificationDTO } from './Types/Field'
import type { ValidationErrorArgsValidatorType, ValidationErrorsValidatorType } from './Types/ValidationError'
import type { ResourceType } from './Types/Resources'

export type enlistDomainErrorType = (name: string, args: ValidationErrorArgsValidatorType) => void
export type fetchResourceType = (resourceName: string) => void | ResourceType

export type ValidatorTools<T> = {
  cloneDeep<T>(value: T): T
}

export interface Validator {
  actualSpecification: ExpandedSpecificationDTO;
  specification: SpecificationDTO;

  constructor(enlistDomainError: enlistDomainErrorType, fetchResource: fetchResourceType,
              tools: ValidatorTools<string>): void;

  validate(values: Values, specification?: ExpandedSpecificationDTO): ValidationErrorsValidatorType;
  cast(values: Values, specification?: ExpandedSpecificationDTO): Values;
  callEffects(values: Values, specification?: SpecificationDTO): ExpandedSpecificationDTO;
  expandSpecification(specification: SpecificationDTO): ExpandedSpecificationDTO;
  filterDisabled(values: Values, specification?: ExpandedSpecificationDTO): Values;
}

export default class FieldValidator {
  validator: Validator

  constructor(enlistDomainError: enlistDomainErrorType,
              fetchResource: fetchResourceType,
              className: string = 'Validator',
              validatorPush?: Validator) {
    this.validator = validatorPush ? validatorPush : new (window)[className](enlistDomainError, fetchResource, {
      cloneDeep: clone
    })
  }

  validate = (values: Values, specification?: ExpandedSpecificationDTO): ValidationErrorsValidatorType => {
    return this.validator.validate(values, specification)
  }

  cast = (values: Values, specification?: ExpandedSpecificationDTO): Values => {
    return this.validator.cast(values, specification)
  }

  filterDisabled = (values: Values, specification?: ExpandedSpecificationDTO): Values => {
    return this.validator.filterDisabled(values, specification)
  }

  callEffects = (values: Values, specification?: SpecificationDTO): ExpandedSpecificationDTO => {
    return this.validator.callEffects(values, specification)
  }

  setActualSpecification = (specification: ExpandedSpecificationDTO): void => {
    this.validator.actualSpecification = specification
  }

  getActualSpecification = (): ExpandedSpecificationDTO => {
    return this.validator.actualSpecification
  }

  getSpecification = (): SpecificationDTO => {
    return this.validator.specification
  }
}
